<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-50 md-size-50">
			<h4>ការគ្រប់គ្រងគូប៉ុង</h4>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<md-card>
				<md-card-content>
					<loading v-if="!loaded" />
					<div v-if="loaded">
						<el-tabs v-model="tabName">
							<el-tab-pane label="គូប៉ុងប្រើបានច្រើនដង" name="first"></el-tab-pane>
							<el-tab-pane label="គូប៉ុងប្រើបានតែម្តង" name="second"></el-tab-pane>
							<el-tab-pane label="បង្កើតគូប៉ុងប្រើបានច្រើនដង" name="third"></el-tab-pane>
							<el-tab-pane label="បង្កើតគូប៉ុងប្រើបានតែម្តង" name="forth"></el-tab-pane>
						</el-tabs>
				
						<div v-if="tabName == 'first'">
							<md-table v-if="generalCouponList.length > 0">
								<md-table-row>
									<md-table-head></md-table-head>
									<md-table-head>ឈ្មោះគូប៉ុង</md-table-head>
									<md-table-head>លេខកូដគូប៉ុង</md-table-head>
									<md-table-head>បញ្ចុះតម្លៃ</md-table-head>
									<md-table-head>នៅសល់</md-table-head>
									<md-table-head>ចំនួនដងមួយគណនី</md-table-head>
									<md-table-head>ចំណូលទទួលបានសរុប</md-table-head>
									<md-table-head>ការកំណត់</md-table-head>
									<md-table-head>ថ្ងៃផុតកំណត់</md-table-head>
				
								</md-table-row>
				
								<md-table-row v-for="(coupon, index) in generalCouponList">
									<md-table-cell>{{ index + 1}}</md-table-cell>
									<md-table-cell>{{ coupon.name }}</md-table-cell>
									<md-table-cell>{{ coupon.code }}</md-table-cell>
									<md-table-cell v-if="coupon.type == 'price'"> បញ្ចុះតម្លៃ {{config.moneylify(coupon.discount_value)}}</md-table-cell>
									<md-table-cell v-if="coupon.type == 'percentage'">បញ្ចុះតម្លៃ {{coupon.discount_value}}%</md-table-cell>
									<md-table-cell>{{ coupon.total }} គូប៉ុង</md-table-cell>
									<md-table-cell>{{ coupon.per_user }} ដង</md-table-cell>
									<md-table-cell><b>{{ config.moneylify(coupon.total_income) }} មកពី {{coupon.total_transaction}} ប្រតិបត្តិការ</b></md-table-cell>
									<md-table-cell>
										<template v-if="coupon.status == 'public'">
											<div style="display: flex; align-items: center;">
												<span class="green">សាធារណៈ</span>
												<md-button class="md-just-icon md-simple md-danger" @click="change_privacy(coupon.code, 'private')">
													<md-tooltip md-direction="top">ដាក់មិនបង្ហាញ</md-tooltip>
													<md-icon>public_off</md-icon>
												</md-button>
											</div>
										</template>
										<template v-if="coupon.status == 'private'">
											<div style="display: flex; align-items: center;">
												<span class="red">មិនបង្ហាញ</span>
												<md-button class="md-just-icon md-simple md-success" @click="change_privacy(coupon.code, 'public')">
													<md-tooltip md-direction="top">ដាក់សាធារណៈ</md-tooltip>
													<md-icon>public</md-icon>
												</md-button>
											</div>
										</template>
										
									</md-table-cell>
									<md-table-cell>{{ config.datelify(coupon.expiry_date)[1] }}</md-table-cell>
								</md-table-row>
							</md-table>
							<h5 class="text-center" v-if="generalCouponList.length == 0 && loaded == true">មិនមានគូប៉ុង</h5>
						</div>
				
						<div v-if="tabName == 'second'">
							<md-table v-if="oneTimeCouponList.length > 0">
								<md-table-row>
									<md-table-head></md-table-head>
									<md-table-head>ឈ្មោះគូប៉ុង</md-table-head>
									<md-table-head>បញ្ចុះតម្លៃ</md-table-head>
									<md-table-head>នៅសល់</md-table-head>
									<md-table-head>ផុតកំណត់</md-table-head>
									<md-table-head>សកម្មភាព</md-table-head>
								</md-table-row>
								<md-table-row v-for="(coupon, index) in oneTimeCouponList">
									<md-table-cell>{{ index + 1}}</md-table-cell>
									<md-table-cell>{{ coupon.name }}</md-table-cell>
									<md-table-cell v-if="coupon.type == 'price'"> បញ្ចុះតម្លៃ {{config.moneylify(coupon.discount_value)}}</md-table-cell>
									<md-table-cell v-if="coupon.type == 'percentage'">បញ្ចុះតម្លៃ {{coupon.discount_value}}%</md-table-cell>
									<md-table-cell>{{ coupon.remain }}/{{ coupon.total }} គូប៉ុង</md-table-cell>
									<md-table-cell>{{ config.datelify(coupon.expiry_date)[1] }}</md-table-cell>
									<md-table-cell>
										<router-link :to="'/coupons/detail/' + coupon.hash">
											<md-button class="md-just-icon md-simple md-primary">
												<md-icon>remove_red_eyes</md-icon>
												<md-tooltip md-direction="top">មើលគូប៉ុងទាំងអស់</md-tooltip>
											</md-button>
										</router-link>
										<md-button class="md-just-icon md-simple md-primary" @click="deleteCoupon(coupon.hash)">
											<md-icon>delete</md-icon>
											<md-tooltip md-direction="top">លុបគូប៉ុងនេះ</md-tooltip>
										</md-button>
									</md-table-cell>
								</md-table-row>
							</md-table>
							<h5 class="text-center" v-if="oneTimeCouponList.length == 0 && loaded == true">មិនមានគូប៉ុង</h5>
						</div>
				
						<div v-if="tabName == 'third'">
							<div class="md-layout">
								<div class="md-layout-item md-small-size-100 md-size-50">
									<md-field>
										<label>ឈ្មោះគូប៉ុង</label>
										<md-input type="text" v-model="generalCoupon.name" @keyup="checkValidationGeneral()"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-25">
									<md-field>
										<label>លេខកូដគូប៉ុង</label>
										<md-input type="text" v-model="generalCoupon.code" @keyup="checkValidationGeneral()"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-25">
									<md-field>
										<md-select name="lang" id="lang" v-model="generalCoupon.type" placeholder="ប្រភេទបញ្ចុះតម្លៃ"
											@keyup="checkValidationGeneral()">
											<md-option value="percentage">បញ្ចុះតម្លៃជាភាគរយ (%)</md-option>
											<md-option value="price">បញ្ចុះតម្លៃជាតម្លៃ (៛)</md-option>
										</md-select>
									</md-field>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-15">
									<md-field>
										<label>បញ្ចុះតម្លៃ (៛/%)</label>
										<md-input type="number" v-model="generalCoupon.discount" @keyup="checkValidationGeneral()"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-20">
									<md-field>
										<label>ចំនួនអាចប្រើប្រាស់បានក្នុងមួយគណនី</label>
										<md-input type="number" v-model="generalCoupon.per_user" @keyup="checkValidationGeneral()"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-15">
									<md-field>
										<label>ចំនួនគូប៉ុងសរុប</label>
										<md-input type="number" v-model="generalCoupon.total" @keyup="checkValidationGeneral()"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-25">
									<md-field>
										<label>ថ្ងៃផុតកំណត់</label>
										<md-input type="text" v-model="generalCoupon.expire" style="display:none"
											@keyup="checkValidationGeneral()" />
										<datetime type="datetime" v-model="generalCoupon.expire" auto></datetime>
									</md-field>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-25">
									<md-field>
										<md-select v-model="generalCoupon.status" placeholder="កំណត់ស្ថានភាព"
											@keyup="checkValidationGeneral()">
											<md-option value="private">មិនបង្ហាញសាធារណៈ</md-option>
											<md-option value="public">បង្ហាញសាធារណៈ</md-option>
										</md-select>
									</md-field>
								</div>
								<div class="md-layout-item md-size-100 text-right">
									<md-button :class="{'md-raised': true, 'md-primary': isValidGeneral}" @click="postGeneralCoupon()"
										:disabled="!isValidGeneral">បង្កើត</md-button>
								</div>
							</div>
						</div>
				
						<div v-if="tabName == 'forth'">
							<div class="md-layout">
								<div class="md-layout-item md-small-size-100 md-size-50">
									<md-field>
										<label>ឈ្មោះគូប៉ុង</label>
										<md-input type="text" v-model="oneTimeCoupon.name" @keyup="checkValidationOne()"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-50">
									<md-field>
										<md-select name="lang" id="lang" v-model="oneTimeCoupon.type" placeholder="ប្រភេទបញ្ចុះតម្លៃ"
											@keyup="checkValidationOne()">
											<md-option value="percentage">បញ្ចុះតម្លៃជាភាគរយ (%)</md-option>
											<md-option value="price">បញ្ចុះតម្លៃជាតម្លៃ (៛)</md-option>
										</md-select>
									</md-field>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-50">
									<md-field>
										<label>បញ្ចុះតម្លៃ (៛/%)</label>
										<md-input type="number" v-model="oneTimeCoupon.discount" @keyup="checkValidationOne()"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-25">
									<md-field>
										<label>ចំនួនគូប៉ុងសរុប</label>
										<md-input type="number" v-model="oneTimeCoupon.total" @keyup="checkValidationOne()"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-25">
									<md-field>
										<label>ថ្ងៃផុតកំណត់</label>
										<md-input type="text" v-model="oneTimeCoupon.expire" style="display:none"
											@keyup="checkValidationOne()" />
										<datetime type="datetime" v-model="oneTimeCoupon.expire" auto></datetime>
									</md-field>
								</div>
				
								<div class="md-layout-item md-size-100 text-right">
									<md-button :class="{'md-raised': true, 'md-primary': isValidOne}" @click="postOneTimeCoupon()"
										:disabled="!isValidOne">បង្កើត</md-button>
								</div>
							</div>
						</div>
				
					</div>

					<!-- <md-dialog-confirm :md-active.sync="disableDialogActive"
						:md-title="'តើអ្នកពិតជាចង់លុបមែនឬ​ ?'" :md-confirm-text="'យល់ព្រម'"
						:md-cancel-text="'បោះបង់'" @md-cancel="onCancel" @md-confirm="onDelete" /> -->
				</md-card-content>
			</md-card>
		</div>
	</div>
</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: {
			datetime: Datetime
		},
		created() {
			this.getGeneralCoupon();
			this.getOneTimeCoupon();
		},
		data() {
			return {
				tabName: 'first',
				loaded: false,
				isValidGeneral: false,
				isValidOne: false,
				generalCouponList: [],
				oneTimeCouponList: [],
				generalCoupon: {
					name: "",
					code: "",
					type: "",
					per_user: 1,
					discount: "",
					total: "",
					expire: "",
					status: ""
				},
				oneTimeCoupon: {
					name: "",
					type: "",
					discount: "",
					total: "",
					expire: ""
				}
			}
		},
		watch: {
			'oneTimeCoupon.expire': function () {
				this.checkValidationOne();
			},
			'generalCoupon.expire': function () {
				this.checkValidationGeneral();
			},
		},
		methods: {
			change_privacy(code, status) {
				this.$http.post(this.config.api + "/user/coupon/update_status", {
					code: code,
					status: status,
				}).then(res => {
					this.getGeneralCoupon();
				});
			},
			getGeneralCoupon(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/user/coupon/get_general_coupon/list/" + offset).then(data => {
					this.generalCouponList = replace ? data.body.data : this.generalCouponList.concat(data.body.data)
					this.loaded = true;
				})
			},
			getOneTimeCoupon(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/user/coupon/get_one_time_coupon/list/" + offset).then(data => {
					this.oneTimeCouponList = replace ? data.body.data : this.oneTimeCouponList.concat(data.body.data)
					this.loaded = true;
				})
			},
			loadMoreGeneralCoupon() {
				this.getGeneralCoupon(this.generalCouponList.length, false);
			},
			loadMoreOneTimeCoupon() {
				this.getOneTimeCoupon(this.oneTimeCouponList.length, false);
			},

			postGeneralCoupon() {
				this.$http.post(this.config.api + "/user/coupon/post_general_coupon", {
					coupon_name: this.generalCoupon.name,
					coupon_type: this.generalCoupon.type,
					coupon_discount: this.generalCoupon.discount,
					coupon_total: this.generalCoupon.total,
					per_user: this.generalCoupon.per_user,
					coupon_expire: (new Date(this.generalCoupon.expire)).getTime(),
					coupon_code: this.generalCoupon.code,
					coupon_status: this.generalCoupon.status
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "បង្កើតគូប៉ុងបានបង្កើតដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						});
						this.isValidGeneral = false
						this.clear();
						this.getGeneralCoupon();
						this.tabName = 'first'
					}
				});
			},
			postOneTimeCoupon() {
				this.$http.post(this.config.api + "/user/coupon/post_one_time_coupon", {
					coupon_name: this.oneTimeCoupon.name,
					coupon_type: this.oneTimeCoupon.type,
					coupon_discount: this.oneTimeCoupon.discount,
					coupon_total: this.oneTimeCoupon.total,
					coupon_expire: (new Date(this.oneTimeCoupon.expire)).getTime()
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "បង្កើតគូប៉ុងបានបង្កើតដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						});
						this.isValidOne = false
						this.clear();
						this.getOneTimeCoupon();
						this.tabName = 'second'
					}
				});
			},
			deleteCoupon(id) {
				this.$http.post(this.config.api + "/user/coupon/delete", {
					hash: id
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "គូប៉ុងបានលុបដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.getGeneralCoupon();
						this.getOneTimeCoupon();
					}
				})
			},

			checkValidationGeneral() {
				this.generalCoupon.code = (this.generalCoupon.code).toUpperCase();
				if (this.generalCoupon.name.length > 2 &&
					this.generalCoupon.type.length > 1 &&
					String(this.generalCoupon.per_user).length > 0 &&
					this.generalCoupon.code.length > 1 &&
					this.generalCoupon.total.length >= 1 &&
					String(this.generalCoupon.expire).length >= 1 &&
					this.generalCoupon.discount.length >= 1 &&
					parseFloat(this.generalCoupon.discount) <= 10000 &&
					parseFloat(this.generalCoupon.discount) > 0 &&
					String(this.generalCoupon.status).length > 0
				) {
					this.isValidGeneral = true
				} else {
					this.isValidGeneral = false
				}
			},
			checkValidationOne() {
				if (this.oneTimeCoupon.name.length > 2 &&
					this.oneTimeCoupon.type.length > 1 &&
					this.oneTimeCoupon.total.length >= 1 &&
					String(this.oneTimeCoupon.expire).length >= 1 &&
					this.oneTimeCoupon.discount.length >= 1 &&
					parseFloat(this.oneTimeCoupon.discount) <= 10000 &&
					parseFloat(this.oneTimeCoupon.discount) > 0
				) {
					this.isValidOne = true
				} else {
					this.isValidOne = false
				}
			},
			clear() {
				this.generalCoupon.name = ""
				this.generalCoupon.code = ""
				this.generalCoupon.type = ""
				this.generalCoupon.discount = ""
				this.generalCoupon.total = ""
				this.generalCoupon.per_user = ""
				this.generalCoupon.expire = ""

				this.oneTimeCoupon.name = ""
				this.oneTimeCoupon.type = ""
				this.oneTimeCoupon.discount = ""
				this.oneTimeCoupon.total = ""
				this.oneTimeCoupon.expire = ""
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Coupons/View.vue